var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    staticClass: "mx-n3 px-3",
    attrs: {
      "width": "100%",
      "max-width": "640",
      "height": "100%"
    }
  }, [_c('list-heading', {
    attrs: {
      "title": "생산보고서 목록"
    }
  }), _c('v-card', {
    staticClass: "mt-4",
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "outlined": ""
    }
  }, [_c('v-data-table', _vm._b({
    attrs: {
      "disable-sort": "",
      "disable-pagination": "",
      "hide-default-footer": "",
      "items-per-page": -1
    },
    on: {
      "click:row": _vm.openItem
    },
    scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header) {
      return {
        key: "item.".concat(header.value),
        fn: function fn(_ref) {
          var value = _ref.value;
          return [_vm._v(" " + _vm._s(header.formatter(value)) + " ")];
        }
      };
    })], null, true)
  }, 'v-data-table', {
    loading: _vm.loading,
    headers: _vm.headers,
    items: _vm.items
  }, false))], 1), _c('v-pagination', {
    staticClass: "mt-4 mx-4",
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11
    },
    on: {
      "input": function input(page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page: page
          })
        });
      }
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }